import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import Show from './Show.vue';
import VenueShow from './VenueShow.vue';

const FloorplanEditor = () => import('./floorplan/FloorplanEditor.vue');

const LayoutEditor = () => import('./floorplan/LayoutEditor.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/spaces'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_spaces_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/spaces/:spaceId'),
      name: 'settings_spaces_show',
      meta: {
        permissions: ['administrator'],
      },
      component: Show,
    },
    {
      path: frontendURL('accounts/:accountId/settings/venues/:venueId'),
      name: 'settings_venues_show',
      meta: {
        permissions: ['administrator'],
      },
      component: VenueShow,
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/spaces/:spaceId/floorplan'
      ),
      name: 'settings_spaces_floorplan',
      meta: {
        permissions: ['administrator'],
      },
      component: FloorplanEditor,
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/spaces/:spaceId/floorplan/layouts/:layoutId'
      ),
      name: 'settings_spaces_floorplan_layout',
      meta: {
        permissions: ['administrator'],
      },
      component: LayoutEditor,
    },
  ],
};
